import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import '../assets/style/RoleModals.css'; 
import { useForm } from "react-hook-form";
import TextInput from "../components/TextInput";
import { editRoleApi } from "../api/roleMasterApi";

interface EditFormData {
    newGroupName: string;
    newDescription: string;
}

const EditRoleModal = (props: any) => {
    const { toggle, openModal, role, setFlag } = props;
    const dispatch: any = useDispatch();

    const handleCloseModal = () => {
        toggle();
        setFlag(false);
    };

    const closeBtn = (
        <img
            src={require('../assets/img/close_modal.svg').default}
            onClick={handleCloseModal}
            className="close-icon"
            alt="Close"
        />
    );

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors},
    } = useForm<EditFormData>();

    const roleName = watch("newGroupName");

    const roleDescription = watch("newDescription");

    const isFormReady =
      roleName &&
      roleDescription &&
      (roleName?.trim() !== role?.name ||
        roleDescription?.trim() !== role?.description);

    const onChangeInput = (label: any, value: any) => {
        setValue(label, value, { shouldValidate: true });
    };

    const onSubmit = (data: EditFormData) => {
    dispatch(editRoleApi(role?.name, data.newGroupName.trim(),data.newDescription.trim(), role?.id));
    setFlag(true)
    };

    const storeEditRoleRes = useSelector((state: any) => state.roleMaster?.storeEditRoleRes);

    useEffect(() => {
        if (storeEditRoleRes?.response === 'updated Successfully') {
            setFlag(true);
            toggle();
        }        
    }, [storeEditRoleRes]);

    useEffect(() => {
        setValue('newGroupName', role?.name)
        setValue('newDescription', role?.description)
    },[])

    return (
        <Modal isOpen={openModal} toggle={toggle} centered backdrop="static" size="lg">
            <ModalHeader toggle={toggle} close={closeBtn}>
                Edit Role
            </ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
                <ModalBody>
                    <Row>
                        <Col xs={6} md={6} className="mb-3">     
                            <TextInput
                                label="Role Name"
                                valueName={'newGroupName'}
                                changeFun={onChangeInput}
                                register={register('newGroupName', { pattern: /^[^#]*$/})}
                                formValue={getValues('newGroupName')}
                                errors={errors}
                                required={true}
                            />
                        </Col>
                        <Col xs={6} md={6} className="mb-3">
                            <TextInput
                                label="Description"
                                valueName={'newDescription'}
                                changeFun={onChangeInput}
                                register={register('newDescription', { pattern: /^[^#]*$/})}
                                formValue={getValues('newDescription')}
                                errors={errors}
                                required={true}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button className="button extra-width" type="submit" disabled={!isFormReady}>
                        Yes
                    </Button>
                    <Button className="resetButton extra-width" onClick={handleCloseModal}>
                        No
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default EditRoleModal;
